import { axiosInstance } from './httpClient';
import { API } from './env';

export default class BlockedUnregisteredUsersApi {
  static getAuthConfig = () => {
    const userInfo = JSON.parse(localStorage.getItem('user'));
    const accessToken = userInfo.token;
    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
  };

  static getAll = (search = '') => {
    const query = search ? `?search=${encodeURIComponent(search)}` : '';
    return axiosInstance.get(
      `${API}/admin/users/blocked-unregistered${query}`,
      this.getAuthConfig()
    );
  };

  static create = (data) => {
    return axiosInstance.post(
      `${API}/admin/users/blocked-unregistered`,
      JSON.stringify(data),
      this.getAuthConfig()
    );
  };
}
